
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {TradingRouteRequestType} from './TradingRouteRequestType';
import {FieldModelTradingRouteRequestType} from './TradingRouteRequestType';
import {TradingRouteCondition} from './TradingRouteCondition';
import {FieldModelTradingRouteCondition} from './TradingRouteCondition';
import {TradingRouteActionDelay} from './TradingRouteActionDelay';
import {FieldModelTradingRouteActionDelay} from './TradingRouteActionDelay';
import {TradingRouteActionType} from './TradingRouteActionType';
import {FieldModelTradingRouteActionType} from './TradingRouteActionType';
import {TradingRouteActionForwardToGateway} from './TradingRouteActionForwardToGateway';
import {FieldModelTradingRouteActionForwardToGateway} from './TradingRouteActionForwardToGateway';

/**
 * TradingRouteRule struct
 */
class TradingRouteRule {
  /**
   * Initialize struct
   * @param {!UUID=} id
   * @param {!boolean=} isEnabled
   * @param {!string=} name
   * @param {!string=} description
   * @param {!number=} sortOrder
   * @param {!Set=} requestType
   * @param {!Array=} condition
   * @param {TradingRouteActionDelay=} actionDelay
   * @param {!TradingRouteActionType=} actionType
   * @param {TradingRouteActionForwardToGateway=} actionForwardToGateway
   * @param {string=} gatewayAccountId
   * @constructor
   */
  constructor (id = UUID.sequential(), isEnabled = false, name = '', description = '', sortOrder = 0, requestType = new Set(), condition = [], actionDelay = null, actionType = new TradingRouteActionType(), actionForwardToGateway = null, gatewayAccountId = null) {
    this.id = id
    this.IsEnabled = isEnabled
    this.Name = name
    this.Description = description
    this.SortOrder = sortOrder
    this.RequestType = requestType
    this.Condition = condition
    this.ActionDelay = actionDelay
    this.ActionType = actionType
    this.ActionForwardToGateway = actionForwardToGateway
    this.GatewayAccountId = gatewayAccountId
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradingRouteRule}
   * @param {!TradingRouteRule} other Other struct
   * @returns {!TradingRouteRule} This struct
   */
  copy (other) {
    if (other.id != null) {
      this.id = new UUID(other.id)
    } else {
      this.id = null
    }
    if (other.IsEnabled != null) {
      this.IsEnabled = other.IsEnabled
    } else {
      this.IsEnabled = null
    }
    if (other.Name != null) {
      this.Name = other.Name
    } else {
      this.Name = null
    }
    if (other.Description != null) {
      this.Description = other.Description
    } else {
      this.Description = null
    }
    if (other.SortOrder != null) {
      this.SortOrder = other.SortOrder
    } else {
      this.SortOrder = null
    }
    if (other.RequestType != null) {
      this.RequestType = new Set()
      for (let item of other.RequestType) {
        if (item != null) {
          let tempItem
          tempItem = TradingRouteRequestType.fromObject(item)
          this.RequestType.add(tempItem)
        } else {
          this.RequestType.add(null)
        }
      }
    } else {
      this.RequestType = null
    }
    if (other.Condition != null) {
      this.Condition = []
      for (let item of other.Condition) {
        if (item != null) {
          let tempItem
          tempItem = TradingRouteCondition.fromObject(item)
          this.Condition.push(tempItem)
        } else {
          this.Condition.push(null)
        }
      }
    } else {
      this.Condition = null
    }
    if (other.ActionDelay != null) {
      this.ActionDelay = TradingRouteActionDelay.fromObject(other.ActionDelay)
    } else {
      this.ActionDelay = null
    }
    if (other.ActionType != null) {
      this.ActionType = TradingRouteActionType.fromObject(other.ActionType)
    } else {
      this.ActionType = null
    }
    if (other.ActionForwardToGateway != null) {
      this.ActionForwardToGateway = TradingRouteActionForwardToGateway.fromObject(other.ActionForwardToGateway)
    } else {
      this.ActionForwardToGateway = null
    }
    if (other.GatewayAccountId != null) {
      this.GatewayAccountId = other.GatewayAccountId
    } else {
      this.GatewayAccountId = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradingRouteRule}
   * @returns {!TradingRouteRule} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradingRouteRuleModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradingRouteRuleModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradingRouteRule}
   * @param {!TradingRouteRule} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradingRouteRule)) {
      throw new TypeError('Instance of TradingRouteRule is required!')
    }
    // noinspection RedundantIfStatementJS
    if (this.id != null) {
      if ((other.id == null) || !this.id.eq(other.id)) {
        return false
      }
    } else if (other.id != null) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradingRouteRule}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      id: ((this.id != null) ? this.id.toString() : null),
      IsEnabled: ((this.IsEnabled != null) ? this.IsEnabled : null),
      Name: ((this.Name != null) ? this.Name : null),
      Description: ((this.Description != null) ? this.Description : null),
      SortOrder: ((this.SortOrder != null) ? this.SortOrder : null),
      RequestType: ((this.RequestType != null) ? Array.from(this.RequestType, item => ((item != null) ? item : null)) : null),
      Condition: ((this.Condition != null) ? Array.from(this.Condition, item => ((item != null) ? item : null)) : null),
      ActionDelay: ((this.ActionDelay != null) ? this.ActionDelay : null),
      ActionType: ((this.ActionType != null) ? this.ActionType : null),
      ActionForwardToGateway: ((this.ActionForwardToGateway != null) ? this.ActionForwardToGateway : null),
      GatewayAccountId: ((this.GatewayAccountId != null) ? this.GatewayAccountId : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradingRouteRule.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradingRouteRule} other Object value
   * @returns {!TradingRouteRule} Created struct
   */
  static fromObject (other) {
    return new TradingRouteRule().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradingRouteRule}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradingRouteRule.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradingRouteRule}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 67
  }
}

export { TradingRouteRule };

/**
 * Fast Binary Encoding TradingRouteRule field model
 */
class FieldModelTradingRouteRule extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.id = new fbe.FieldModelUUID(buffer, 4 + 4)
    this.IsEnabled = new fbe.FieldModelBool(buffer, this.id.fbeOffset + this.id.fbeSize)
    this.Name = new fbe.FieldModelString(buffer, this.IsEnabled.fbeOffset + this.IsEnabled.fbeSize)
    this.Description = new fbe.FieldModelString(buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.SortOrder = new fbe.FieldModelUInt32(buffer, this.Description.fbeOffset + this.Description.fbeSize)
    this.RequestType = new fbe.FieldModelSet(new FieldModelTradingRouteRequestType(buffer, this.SortOrder.fbeOffset + this.SortOrder.fbeSize), buffer, this.SortOrder.fbeOffset + this.SortOrder.fbeSize)
    this.Condition = new fbe.FieldModelVector(new FieldModelTradingRouteCondition(buffer, this.RequestType.fbeOffset + this.RequestType.fbeSize), buffer, this.RequestType.fbeOffset + this.RequestType.fbeSize)
    this.ActionDelay = new fbe.FieldModelOptional(new FieldModelTradingRouteActionDelay(buffer, this.Condition.fbeOffset + this.Condition.fbeSize), buffer, this.Condition.fbeOffset + this.Condition.fbeSize)
    this.ActionType = new FieldModelTradingRouteActionType(buffer, this.ActionDelay.fbeOffset + this.ActionDelay.fbeSize)
    this.ActionForwardToGateway = new fbe.FieldModelOptional(new FieldModelTradingRouteActionForwardToGateway(buffer, this.ActionType.fbeOffset + this.ActionType.fbeSize), buffer, this.ActionType.fbeOffset + this.ActionType.fbeSize)
    this.GatewayAccountId = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.ActionForwardToGateway.fbeOffset + this.ActionForwardToGateway.fbeSize), buffer, this.ActionForwardToGateway.fbeOffset + this.ActionForwardToGateway.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.id.fbeSize + this.IsEnabled.fbeSize + this.Name.fbeSize + this.Description.fbeSize + this.SortOrder.fbeSize + this.RequestType.fbeSize + this.Condition.fbeSize + this.ActionDelay.fbeSize + this.ActionType.fbeSize + this.ActionForwardToGateway.fbeSize + this.GatewayAccountId.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.id.fbeExtra + this.IsEnabled.fbeExtra + this.Name.fbeExtra + this.Description.fbeExtra + this.SortOrder.fbeExtra + this.RequestType.fbeExtra + this.Condition.fbeExtra + this.ActionDelay.fbeExtra + this.ActionType.fbeExtra + this.ActionForwardToGateway.fbeExtra + this.GatewayAccountId.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradingRouteRule.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 67
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradingRouteRule}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradingRouteRule}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.id.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.id.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.id.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.IsEnabled.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Description.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.SortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SortOrder.fbeSize

    if ((fbeCurrentSize + this.RequestType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestType.fbeSize

    if ((fbeCurrentSize + this.Condition.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Condition.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Condition.fbeSize

    if ((fbeCurrentSize + this.ActionDelay.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ActionDelay.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActionDelay.fbeSize

    if ((fbeCurrentSize + this.ActionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ActionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActionType.fbeSize

    if ((fbeCurrentSize + this.ActionForwardToGateway.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ActionForwardToGateway.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActionForwardToGateway.fbeSize

    if ((fbeCurrentSize + this.GatewayAccountId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.GatewayAccountId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayAccountId.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradingRouteRule}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradingRouteRule}
   * @param {!TradingRouteRule} fbeValue Default value, defaults is new TradingRouteRule()
   * @returns {!TradingRouteRule} TradingRouteRule value
   */
  get (fbeValue = new TradingRouteRule()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradingRouteRule}
   * @param {!TradingRouteRule} fbeValue TradingRouteRule value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.id.fbeSize) <= fbeStructSize) {
      fbeValue.id = this.id.get(UUID.sequential())
    } else {
      fbeValue.id = UUID.sequential()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.id.fbeSize

    if ((fbeCurrentSize + this.IsEnabled.fbeSize) <= fbeStructSize) {
      fbeValue.IsEnabled = this.IsEnabled.get()
    } else {
      fbeValue.IsEnabled = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.IsEnabled.fbeSize

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) <= fbeStructSize) {
      fbeValue.Description = this.Description.get()
    } else {
      fbeValue.Description = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.SortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.SortOrder = this.SortOrder.get()
    } else {
      fbeValue.SortOrder = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SortOrder.fbeSize

    if ((fbeCurrentSize + this.RequestType.fbeSize) <= fbeStructSize) {
      this.RequestType.get(fbeValue.RequestType)
    } else {
      fbeValue.RequestType.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestType.fbeSize

    if ((fbeCurrentSize + this.Condition.fbeSize) <= fbeStructSize) {
      this.Condition.get(fbeValue.Condition)
    } else {
      fbeValue.Condition.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Condition.fbeSize

    if ((fbeCurrentSize + this.ActionDelay.fbeSize) <= fbeStructSize) {
      fbeValue.ActionDelay = this.ActionDelay.get()
    } else {
      fbeValue.ActionDelay = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActionDelay.fbeSize

    if ((fbeCurrentSize + this.ActionType.fbeSize) <= fbeStructSize) {
      fbeValue.ActionType = this.ActionType.get()
    } else {
      fbeValue.ActionType = new TradingRouteActionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActionType.fbeSize

    if ((fbeCurrentSize + this.ActionForwardToGateway.fbeSize) <= fbeStructSize) {
      fbeValue.ActionForwardToGateway = this.ActionForwardToGateway.get()
    } else {
      fbeValue.ActionForwardToGateway = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ActionForwardToGateway.fbeSize

    if ((fbeCurrentSize + this.GatewayAccountId.fbeSize) <= fbeStructSize) {
      fbeValue.GatewayAccountId = this.GatewayAccountId.get()
    } else {
      fbeValue.GatewayAccountId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.GatewayAccountId.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradingRouteRule}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradingRouteRule}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradingRouteRule}
   * @param {!TradingRouteRule} fbeValue TradingRouteRule value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradingRouteRule}
   * @param {TradingRouteRule} fbeValue TradingRouteRule value
   */
  setFields (fbeValue) {
    this.id.set(fbeValue.id)
    this.IsEnabled.set(fbeValue.IsEnabled)
    this.Name.set(fbeValue.Name)
    this.Description.set(fbeValue.Description)
    this.SortOrder.set(fbeValue.SortOrder)
    this.RequestType.set(fbeValue.RequestType)
    this.Condition.set(fbeValue.Condition)
    this.ActionDelay.set(fbeValue.ActionDelay)
    this.ActionType.set(fbeValue.ActionType)
    this.ActionForwardToGateway.set(fbeValue.ActionForwardToGateway)
    this.GatewayAccountId.set(fbeValue.GatewayAccountId)
  }
}

export { FieldModelTradingRouteRule };

/**
 * Fast Binary Encoding TradingRouteRule model
 */
class TradingRouteRuleModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradingRouteRule(this.buffer, 4)
  }

  /**
   * Get the TradingRouteRule model
   * @this {!TradingRouteRuleModel}
   * @returns {!FieldModelTradingRouteRule} model TradingRouteRule model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradingRouteRuleModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradingRouteRuleModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradingRouteRuleModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradingRouteRuleModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradingRouteRule.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradingRouteRuleModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradingRouteRuleModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradingRouteRuleModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradingRouteRuleModel}
   * @param {!TradingRouteRule} value TradingRouteRule value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradingRouteRuleModel}
   * @param {!TradingRouteRule} value TradingRouteRule value, defaults is new TradingRouteRule()
   * @return {!object} Deserialized TradingRouteRule value and its size
   */
  deserialize (value = new TradingRouteRule()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradingRouteRule(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradingRouteRule(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradingRouteRuleModel}
   * @param {!number} prev Previous TradingRouteRule model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradingRouteRuleModel };
